var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrashOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "recycle-bin-1",
    clipPath: "url(#clip0_2706_8201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23968 0.0842682C7.3571 0.0579426 7.52389 0.0290125 7.61031 0.0199892C8.68037 -0.0917689 9.70432 0.26825 10.4569 1.02083C10.9384 1.50235 11.2546 2.06909 11.4046 2.71956L11.4465 2.90096H13.7232H16V3.487V4.07305H15.1628C14.6108 4.07305 14.3256 4.07947 14.3256 4.09186C14.3256 4.11925 12.8956 15.5687 12.8832 15.6405L12.8727 15.701H8H3.12727L3.11684 15.6405C3.10445 15.5687 1.67442 4.11925 1.67442 4.09186C1.67442 4.07947 1.38917 4.07305 0.837209 4.07305H0V3.487V2.90096H2.27678H4.55354L4.59539 2.71956C4.89823 1.40646 5.93025 0.377961 7.23968 0.0842682ZM5.94541 2.41681C6.27468 1.77928 6.90673 1.31921 7.61743 1.19973C7.82097 1.16552 8.15901 1.16498 8.36599 1.19856C9.21111 1.33562 9.91386 1.92749 10.1951 2.73908L10.248 2.89165L9.12398 2.89645C8.50579 2.8991 7.49384 2.8991 6.8752 2.89645L5.7504 2.89165L5.80318 2.74081C5.83222 2.65783 5.89622 2.51205 5.94541 2.41681ZM4.14884 14.51C4.14884 14.4855 2.86878 4.23426 2.85429 4.14282L2.84324 4.07305H8H13.1568L13.1457 4.14282C13.1312 4.23426 11.8512 14.4855 11.8512 14.51C11.8512 14.5227 10.5869 14.5289 8 14.5289C5.41308 14.5289 4.14884 14.5227 4.14884 14.51ZM6.40001 6.39863L6.78761 12.2224L5.62481 12.2126L5.2278 6.39863H6.40001ZM9.60001 6.39863L9.21241 12.2224L10.3752 12.2126L10.7722 6.39863H9.60001Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2706_8201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashOutline);
export default __webpack_public_path__ + "static/media/icon--trash-outline.62e3867afb99ac3c810d5fea10b7684c.svg";
export { ForwardRef as ReactComponent };